/**
 * Founder 2026-10-22: `503 {"detail": "provisioning_unavailable"}` + `Retry-After` means OUR side could
 * not create the account's row (the database or Cognito did not answer) — the token is fine. The
 * client repeats the request after `Retry-After` and never signs out; `401` stays the only "the
 * token is invalid, expired or revoked" answer.
 */

/** Two repeats: the API's outage window is 10 s; a conflict (60 s) is not waited out in a request. */
export const PROVISIONING_MAX_RETRIES = 2
export const PROVISIONING_MAX_WAIT_MS = 15_000
const DEFAULT_WAIT_MS = 2_000

/** A 503 `provisioning_unavailable` — whether or not it is still worth repeating (never a sign-out). */
export function isProvisioningUnavailable(status: number | undefined, data: unknown): boolean {
  const detail = typeof data === 'object' && data !== null ? (data as { detail?: unknown }).detail : undefined
  return status === 503 && detail === 'provisioning_unavailable'
}

/** The wait before the next attempt, or null when this answer is not a retryable provisioning 503. */
export function provisioningRetryDelayMs(
  status: number | undefined,
  data: unknown,
  retryAfter: string | null | undefined,
  attempt: number,
): number | null {
  if (attempt >= PROVISIONING_MAX_RETRIES || !isProvisioningUnavailable(status, data)) return null
  const seconds = Number(retryAfter)
  const wait = Number.isFinite(seconds) && seconds >= 0 ? seconds * 1000 : DEFAULT_WAIT_MS
  return wait > PROVISIONING_MAX_WAIT_MS ? null : wait
}
